<!-- eslint-disable -->
<template>
    <el-container>
        <el-row class="list-container">
            <el-col :span="24">
                <el-button @click="refreshData" type="primary" size="small" icon="iconfont icon-shuaxin shuaxin">刷新</el-button>
                <el-button type="success" size="small" icon="iconfont icon-daochu shuaxin" @click="exportExcel">导出Excel</el-button>
                <!-- <el-tag style="margin-left: 10px;">总手续费：{{handling_fee_sum}}</el-tag> -->
            </el-col>

            <!-- search start  -->
            <el-col :span="24" class="search-content">
              <div class="search-item">
                <el-date-picker
                  v-model="data.created_at"
                  size="small"
                  :picker-options="pickerOptions"
                  type="datetimerange"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间">
                </el-date-picker>
              </div>
                <div class="search-item" style="width: 130px;">
                    <el-select v-model="data.status" placeholder="请选择状态" size="small" clearable>
                        <el-option
                            v-for="item in [
                              {id: '0', name: '待处理'},
                              {id: '1', name: '提现成功'},
                              {id: '2', name: '提现失败'},
                            ]"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div class="search-item">
                    <el-input v-model="data.nickname" size="small" placeholder="请输入会员昵称" clearable></el-input>
                </div>
                <div class="search-item">
                    <el-button size="small" icon="iconfont icon-fangdajing shuaxin" @click="search">搜索</el-button>
                </div>
            </el-col>
            <!-- search end  -->

            <el-col class="main-content">
                <el-table :data="dataList" border @selection-change="handleSelectionChange" v-loading="loading" style="width: 100%">
                    <!-- <el-table-column type="selection" width="55"></el-table-column> -->
                    <el-table-column prop="id" label="ID" width="80"></el-table-column>

                    <el-table-column prop="user_id" label="会员昵称" width="150">
                      <template slot-scope="scope">
                        <span>{{scope.row.nickname}} (ID: {{scope.row.user_id}})</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="account_name" label="姓名" width="100"></el-table-column>
                    <el-table-column prop="bank_card_no" label="银行账号" width="220"></el-table-column>
                    <el-table-column prop="bank_name" label="开户行" width="220"></el-table-column>
                    <el-table-column prop="status" label="提现金额" width="120">
                      <template slot-scope="scope">
                        <span style="color: #67C23A;">￥{{scope.row.money}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="status" label="状态" width="100">
                      <template slot-scope="scope">
                        <span v-if="scope.row.status == 0" style="color: #409EFF;">待处理</span>
                        <span v-else-if="scope.row.status == 1" style="color: #67C23A;">提现成功</span>
                        <span v-else style="color: #F56C6C;">提现失败</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="remarks" label="提现失败原因" width="180"></el-table-column>
                    <el-table-column prop="created_at" label="申请时间" width="180"></el-table-column>
                    <el-table-column label="操作" min-width="180">
                        <template slot-scope="scope" v-if="scope.row.status == 0">
                            <el-button @click="agree(scope.row.id)" type="success" size="mini" plain :disabled="!power.user_cash_set_status">同意</el-button>
                            <el-button @click="refuseTmp(scope.row)" size="mini" type="danger" plain :disabled="!power.user_cash_set_status">拒绝</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
            <el-col class="pagination">
                <el-pagination
                    @current-change="changePage"
                    @size-change="changePageSize"
                    background
                    :layout="pageLayout"
                    :page-sizes="pagePageSizes"
                    :page-size="pagePageSize"
                    :total="totalCount"
                    :current-page.sync="current_page"
                    :hide-on-single-page="false">
                </el-pagination>
            </el-col>
        </el-row>

        <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" @close="dialogClose" width="550px" :close-on-click-modal="false" center>
            <el-form :model="form" ref="form" class="dialog-form" @submit.native.prevent>
                <el-form-item label="拒绝原因"
                    :label-width="formLabelWidth"
                    prop="remarks"
                    :rules="[
                    { required: false, message: '请输入拒绝原因', trigger: 'blur' }
                    ]">
                    <el-input type="text" v-model="form.remarks" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="refuse('form')">确 定</el-button>
            </div>
        </el-dialog>
    </el-container>
</template>

<!-- eslint-disable -->
<script>
    import {UserCashIndex, UserCashSetStatus} from "@/utils/request.js"
    import {mapState} from 'vuex'

    export default {
        data(){
            return {
                data: {
                    page: 1,
                    page_size: this.pagePageSize,
                    status: '',
                    nickname: '',
                    created_at: '',
                },
                loading: false,
                dataList: [],
                totalCount: 0,
                current_page: 1,
                dialogFormVisible: false,
                loadingAdd: false,
                dialogTitle: "提示",
                formLabelWidth: "120px",
                form: {
                    id: 0,
                    remarks: "",
                },
                multipleSelection: [],
                pickerOptions: {
                  shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                      const end = new Date();
                      const start = new Date();
                      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                      picker.$emit('pick', [start, end]);
                    }
                  }, {
                    text: '最近一个月',
                    onClick(picker) {
                      const end = new Date();
                      const start = new Date();
                      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                      picker.$emit('pick', [start, end]);
                    }
                  }, {
                    text: '最近三个月',
                    onClick(picker) {
                      const end = new Date();
                      const start = new Date();
                      start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                      picker.$emit('pick', [start, end]);
                    }
                  }]
                },
            }
        },
        created() {
            this.getList()
        },
        computed: mapState(['loginInfo', 'power']),
        methods: {
            search() {
                this.data.page = 1
                this.current_page = 1
                this.getList()
            },
            refreshData() {
                this.data.page = 1
                this.current_page = 1
                this.loading = true

                this.getList()
            },
            getList() {
                this.loading = true
                UserCashIndex(this.data).then((res) => {
                    if (res.code == 200) {
                        this.data.page++
                        this.dataList = res.data.data
                        this.totalCount = res.data.count
                    } else {
                        this.$message.error("数据获取失败!")
                    }
                    this.loading = false
                })
            },
            changePage(page) {
                this.data.page = page
                this.getList()
            },
            changePageSize(size) {
                this.data.page_size = size
                this.data.page = 1
                this.current_page = 1
                this.getList()
            },
            addData(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.loadingAdd = true
                        UserCashAdd(this.form).then((res) => {
                            if (res.code == 200) {
                                this.$message.success(res.msg);
                                this.dialogFormVisible = false
                                this.data.page--
                                this.getList()
                            } else {
                                this.$message.error(res.msg);
                            }
                            this.loadingAdd = false
                        })
                    }
                });
            },
            dialogClose() {
                this.initForm()
            },
            initForm() {
                // 初始化，form数据
                this.form = {
                    id: 0,
                    remarks: '',
                    ac_type: 'refuse'
                }
                // 重置字段验证
                this.$refs["form"].resetFields();
            },
            handleSelectionChange(val) {
                this.multipleSelection = []
                if (val.length > 0) {
                    val.filter((item) => {
                        this.multipleSelection.push(item.id)
                    })
                }
            },
            agree(id) {
                this.$confirm("确定要执行同意提现操作吗?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "success"
                }).then(() => {
                    UserCashSetStatus({id: id, ac_type: 'agree'}).then((res) => {
                        if (res.code == 200) {
                            this.data.page--
                            this.getList()
                            this.$message.success(res.msg);
                        } else {
                            this.$message.error(res.msg);
                        }
                    })
                }).catch(() => {
                    // 取消操作
                });
            },
            refuseTmp(data) {
                this.form = {
                    id: data.id,
                    message: '',
                    ac_type: 'refuse'
                }
                this.dialogFormVisible = true
            },
            refuse(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.loadingAdd = true
                        UserCashSetStatus(this.form).then((res) => {
                            if (res.code == 200) {
                                this.$message.success(res.msg);
                                this.dialogFormVisible = false
                                this.data.page--
                                this.getList()
                            } else {
                                this.$message.error(res.msg);
                            }
                            this.loadingAdd = false
                        })
                    }
                });
            },
            exportExcel(type) {
              this.$confirm("确定要导出列表数据吗?", "提示", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "success"
              }).then(() => {
                  let url = '';
                  for(var k in this.data){
                    let value = this.data[k] !==undefined ? this.data[k] : '';
                    if (k == 'page') { continue }
                    url += `&${k}=${encodeURIComponent(value)}`
                  }
                  url += `&type=${type}`
                  location.href = this.loginInfo.app_url+'/manage/user-cash/excel?' + url.substring(1)
              }).catch(() => {
                  // 取消操作
              });
            },
        }
    }
</script>

<style>
</style>
